module.exports = __webpack_public_path__ + "img/about-hero-m.9b4f2128.jpg";